import { render } from "./TabsPanelComponent.vue?vue&type=template&id=12db5e38&scoped=true"
import script from "./TabsPanelComponent.vue?vue&type=script&lang=js"
export * from "./TabsPanelComponent.vue?vue&type=script&lang=js"

import "./TabsPanelComponent.vue?vue&type=style&index=0&id=12db5e38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12db5e38"]])

export default __exports__